module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('b-loading', {
    attrs: {
      "active": _vm.isLoading,
      "canCancel": true
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "columns is-fullheight"
  }, [_c('div', {
    staticClass: "column is-2 is-sidebar-menu"
  }, [_c('aside', {
    staticClass: "menu"
  }, [(_vm.isAdmin) ? _c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n            General\n        ")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, [_c('li', [_c('a', {
    class: _vm.content == 'list_file' ? 'is-active' : 'color-white',
    on: {
      "click": function($event) {
        return _vm.swap_content('list_file')
      }
    }
  }, [_vm._v("\n                Download Documents\n            ")])]), _vm._v(" "), _c('li', [_vm._v(" ")]), _vm._v(" "), _c('li', [_c('a', {
    class: _vm.content == 'upload_file' ? 'is-active' : 'color-white',
    on: {
      "click": function($event) {
        return _vm.swap_content('upload_file')
      }
    }
  }, [_vm._v("\n                Upload Documents\n            ")])]), _vm._v(" "), (_vm.sheetURL) ? _c('li', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.sheetURL) ? _c('li', [_c('a', {
    class: _vm.content == 'timesheet' ? 'is-active' : 'color-white',
    on: {
      "click": function($event) {
        return _vm.swap_content('timesheet')
      }
    }
  }, [_vm._v("\n                Payroll Worksheet\n            ")])]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v(" ")]), _vm._v(" "), _c('li', [_c('a', {
    class: _vm.content == 'share_screen' ? 'is-active' : 'color-white',
    on: {
      "click": function($event) {
        return _vm.alert()
      }
    }
  }, [_vm._v("\n                Share Screen " + _vm._s(_vm.isAdmin ? '(Chrome)' : '') + "\n            ")])])]), _vm._v(" "), (_vm.isAdmin) ? _c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n            Administration\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('ul', {
    staticClass: "menu-list"
  }, [(_vm.isAdmin) ? _c('li', [_c('a', {
    class: _vm.content == 'manage_user' ? 'is-active' : 'color-white',
    on: {
      "click": function($event) {
        return _vm.swap_content('manage_user')
      }
    }
  }, [_vm._v("Manage Users")])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "column is-main-content"
  }, [(_vm.content == 'list_file') ? _c('div', [(_vm.isAdmin) ? _c('div', [_c('admin-download-table', {
    attrs: {
      "isAdmin": _vm.isAdmin,
      "files": _vm.files,
      "users": _vm.arrUsers,
      "isLoading": _vm.isLoading
    }
  })], 1) : _c('div', {}, [_c('download-table', {
    attrs: {
      "isAdmin": _vm.isAdmin,
      "files": _vm.files,
      "isLoading": _vm.isLoading
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.content == 'upload_file') ? _c('div', [_c('upload-table', {
    attrs: {
      "isAdmin": _vm.isAdmin,
      "files": _vm.uploadFiles,
      "users": _vm.arrUsers
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter is-hidden-touch"
  }), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notes),
      expression: "notes"
    }],
    staticClass: "textarea is-info",
    attrs: {
      "name": "upload_note",
      "rows": "5",
      "placeholder": "Enter your notes here..."
    },
    domProps: {
      "value": (_vm.notes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.notes = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "file is-centered is-boxed is-default has-name"
  }, [_c('label', [_c('b-field', {
    staticClass: "file"
  }, [_c('b-upload', {
    model: {
      value: (_vm.selectedFiles),
      callback: function($$v) {
        _vm.selectedFiles = $$v
      },
      expression: "selectedFiles"
    }
  }, [_c('a', {
    staticClass: "button is-default"
  }, [_c('b-icon', {
    attrs: {
      "icon": "upload"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Choose file")])], 1)]), _vm._v(" "), (_vm.selectedFiles) ? _c('span', {
    staticClass: "file-name"
  }, [_vm._v("\n                        " + _vm._s(_vm.selectedFiles.name ? _vm.selectedFiles.name : 'No file chosen') + "\n                        ")]) : _vm._e()], 1)], 1)])]), _vm._v(" "), _c('progress', {
    staticClass: "progress is-primary",
    attrs: {
      "id": "upload_progress_bar",
      "max": "100"
    },
    domProps: {
      "value": _vm.progress
    }
  }, [_vm._v(_vm._s(_vm.progress) + "%")]), _vm._v(" "), (_vm.isAdmin) ? _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("For Client:")]), _vm._v(" "), _c('b-select', {
    attrs: {
      "expanded": true
    },
    model: {
      value: (_vm.selectedUser),
      callback: function($$v) {
        _vm.selectedUser = $$v
      },
      expression: "selectedUser"
    }
  }, _vm._l((_vm.arrUsers), function(user, id) {
    return _c('option', {
      key: id,
      domProps: {
        "value": id
      }
    }, [(!user.email) ? [_vm._v("\n                        -- Select One --\n                    ")] : [_vm._v("\n                        " + _vm._s(user.displayName) + " (" + _vm._s(user.email) + ")\n                    ")]], 2)
  }), 0)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-third"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-third"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "button is-large is-primary",
    attrs: {
      "type": "button",
      "name": "button",
      "disabled": _vm.isAdmin && !_vm.selectedUser
    },
    on: {
      "click": _vm.upload
    }
  }, [_vm._v("Submit")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-quarter is-hidden-touch"
  })])])], 1) : _vm._e(), _vm._v(" "), (_vm.content == 'timesheet') ? _c('div', {
    staticClass: "has-text-centered"
  }, [(_vm.isAdmin) ? _c('div', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-third"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-third"
  }, [_c('br'), _vm._v(" "), _c('b-select', {
    attrs: {
      "expanded": true
    },
    model: {
      value: (_vm.selectedUser),
      callback: function($$v) {
        _vm.selectedUser = $$v
      },
      expression: "selectedUser"
    }
  }, _vm._l((_vm.arrUsers), function(user, id) {
    return _c('option', {
      key: id,
      domProps: {
        "value": id
      }
    }, [(!user.email) ? [_vm._v("\n                    -- Select One --\n                    ")] : [_vm._v("\n                    " + _vm._s(user.displayName) + " (" + _vm._s(user.email) + ")\n                    ")]], 2)
  }), 0), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), (_vm.arrSheetURL[_vm.selectedUser]) ? _c('iframe', {
    staticStyle: {
      "overflow": "hidden",
      "height": "800px",
      "width": "100%"
    },
    attrs: {
      "src": _vm.arrSheetURL[_vm.selectedUser],
      "frameborder": "0",
      "marginheight": "0",
      "marginwidth": "0",
      "width": "100%",
      "height": "100%",
      "scrolling": "auto"
    }
  }) : _vm._e()]) : _c('div', [(_vm.sheetURL) ? _c('iframe', {
    staticStyle: {
      "overflow": "hidden",
      "height": "800px",
      "width": "100%"
    },
    attrs: {
      "src": _vm.sheetURL,
      "frameborder": "0",
      "marginheight": "0",
      "marginwidth": "0",
      "width": "100%",
      "height": "100%",
      "scrolling": "auto"
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.content == 'share_screen') ? _c('div', {
    staticClass: "has-text-centered"
  }, [_c('b-button', {
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "type": "is-primary"
    },
    on: {
      "click": _vm.alert
    }
  }, [_vm._v("\n            " + _vm._s(_vm.isAdmin ? 'View Client Shared Screen' : 'Open Shared Screen Window') + "\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.content == 'manage_user' && _vm.isAdmin) ? _c('div', [(_vm.isAdmin) ? _c('manage-users') : _vm._e()], 1) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-143f91f6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin.vue
// module id = 506
// module chunks = 1